import { render, staticRenderFns } from "./manageQuickReply.vue?vue&type=template&id=6800ec40&"
import script from "./manageQuickReply.vue?vue&type=script&lang=ts&"
export * from "./manageQuickReply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports